import { render } from "./LogsView.vue?vue&type=template&id=4aa66605"
import script from "./LogsView.vue?vue&type=script&lang=js"
export * from "./LogsView.vue?vue&type=script&lang=js"

import "./LogsView.vue?vue&type=style&index=0&id=4aa66605&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__